import {useDispatch} from "react-redux";

import {
  getOptionsData,
  getListData,
  setDownloadData,
  clearDownload,
  clearListState,
  reset,
  getFiltersData,
  getDetailsWebhookData,
  clearDetailsWebhook,
  getColumnsData,
  clearColumnsState,
  triggerPostbackData,
  clearTriggerPostback,
  bulkResendPostbackData,
  clearBulkResendPostback,
  getPostbackListData,
  clearPostbackList,
  getTrackerListData,
  clearTrackerList,
} from "./index";

export const useWebhooksReport = () => {
  const dispatch = useDispatch();

  const getOptions = () => dispatch(getOptionsData());
  const getList = (data: any) => dispatch(getListData(data));
  const setDownload = (data: any) => dispatch(setDownloadData(data));

  const clearListData = () => dispatch(clearListState());
  const resetState = () => dispatch(reset());
  const clearDownloadState = () => dispatch(clearDownload());
  const clearDetailsWebhookState = () => dispatch(clearDetailsWebhook());

  const getFiltersList = (data:any) => dispatch(getFiltersData(data));
  const getDetailsWebhook = (data:any) => dispatch(getDetailsWebhookData(data));

  const getColumns = () => dispatch(getColumnsData());
  const clearColumns = () => dispatch(clearColumnsState());

  const triggerPostback = (data: any) => dispatch(triggerPostbackData(data));
  const clearTriggerPostbackState = () => dispatch(clearTriggerPostback());

  const bulkResendPostback = (data: any) => dispatch(bulkResendPostbackData(data));
  const clearBulkResendPostbackState = () => dispatch(clearBulkResendPostback());

  const getPostbackList = (data: any) => dispatch(getPostbackListData(data));
  const clearPostbackListState = () => dispatch(clearPostbackList());

  const getTrackerList = (data: any) => dispatch(getTrackerListData(data));
  const clearTrackerListState = () => dispatch(clearTrackerList());

  return {
    getOptions,
    getList,
    setDownload,
    clearDownloadState,
    clearListData,
    resetState,
    getFiltersList,
    clearDetailsWebhookState,
    getDetailsWebhook,
    getColumns,
    clearColumns,
    triggerPostback,
    clearTriggerPostbackState,
    bulkResendPostback,
    clearBulkResendPostbackState,
    getPostbackList,
    clearPostbackListState,
    getTrackerList,
    clearTrackerListState,
  }
}
